import React, { useState } from "react";
import './PanelOperacionesEstatusRutas.scss'
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import logo from '../../../assets/img/logo.png'
import InputCalendario from "../../../components/atoms/InputCalendario/InputCalendario";
import GlobalCard from "../../../components/atoms/GlobalCard/GlobalCard";
import Boton from "../../../components/atoms/Boton/Boton";

const PanelOperacionesEstatusRutas = ()=>
{
    const navigate = useNavigate()
    const [porFecha, setPorFecha] = useState(false)
    const [fechaInicio, setFechaInicio] = useState()
    const [fechaFin, setFechaFin] = useState()
    const formatearFecha = (fecha, setState) => {
        var año = fecha.getFullYear();
        var mes = ('0' + (fecha.getMonth() + 1)).slice(-2); // Se agrega 1 al mes ya que los meses en JavaScript van de 0 a 11
        var dia = ('0' + fecha.getDate()).slice(-2);
        var fechaFormateada = año + '-' + mes + '-' + dia;
        setState(fechaFormateada)
    }
   
    const onsubmitFunction = ()=>
    {
        if(fechaFin && fechaInicio)
        {
            
            // getDataFecha(fechaInicio,fechaFin,navigate)
            /*Swal.fire({
                position: "center",
                icon: "success",
                title: "Accediendo...",
                showConfirmButton: false,
                timer: 1500
            });*/
            navigate("/operaciones/estatusrutas/"+fechaInicio+"_"+fechaFin)

        }
        else
        {
            alert("Es necesario llenar todos los campos solicitados")   
        }
    }
    const onsubmitFunctionRealTime = ()=>
    {
        // getDataRealTime(navigate)
        /*Swal.fire({
            position: "center",
            icon: "success",
            title: "Accediendo...",
            showConfirmButton: false,
            timer: 1500
        });*/
        navigate("/operaciones/estatusrutas/0")
    }
    return (
        <div className="PanelOperacionesEstatusRutas">
            <div className="header">
                {/* <div className="title">ESTATUS DE RUTAS</div> */}
                <img className="logo" src={logo} alt=''></img>
            </div>
            <div className="centrado">
                <GlobalCard>
                    <div className="button-container">
                        <Boton className="responsive-button" width="50%" onClick={()=>{onsubmitFunctionRealTime()}}>Tiempo real</Boton>
                        <Boton className="responsive-button" width="50%" onClick={() => { setPorFecha(!porFecha) }}>Buscar por fecha</Boton>
                    </div>
                    {
                        porFecha ?
                            <>
                                <div className="cardWhite">
                                    <InputCalendario obligatorio titulo={"Fecha de inicio"} onChange={(e) => { formatearFecha(e.value, setFechaInicio) }}></InputCalendario>
                                    <div style={{ marginTop: "10px" }}></div>
                                    <InputCalendario obligatorio titulo={"Fecha de fin"} onChange={(e) => { formatearFecha(e.value, setFechaFin) }}></InputCalendario>
                                    <div style={{ marginTop: "10px" }}></div>
                                    <div className="buttonCenter">
                                        <Boton className="boton" onClick={()=>{onsubmitFunction()}}>Buscar</Boton>
                                    </div>
                                </div>
                            </> : ""
                    }
                </GlobalCard>
            </div>
        </div>
    )
}
export default PanelOperacionesEstatusRutas